import { Box, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

import type { BarColors } from '@/features/bidding/components/cascading/bid-ladder/shared/getBarColors'

type BidLadderEmptyDropZoneProps = {
  colors: BarColors
}

/**
 * Empty state component shown when a bid level has no groups assigned
 * and drag/drop is enabled. Displays a pulsing "Drop here" indicator.
 */
function BidLadderEmptyDropZone({ colors }: Readonly<BidLadderEmptyDropZoneProps>) {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        flex: 1,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '4px',
        outline: '2px dashed',
        outlineColor: colors.barColorMedium,
        outlineOffset: '-2px',
        backgroundColor: alpha(colors.barColorDark, 0.05),
        animation: 'pulse 3s ease-in-out infinite',
        '@keyframes pulse': {
          '0%, 100%': { opacity: 0.6 },
          '50%': { opacity: 1 },
        },
      }}
    >
      <Typography
        sx={{
          fontSize: '0.625rem',
          fontWeight: 500,
          color: colors.barColorDark,
          userSelect: 'none',
          lineHeight: 1,
        }}
        variant="caption"
      >
        {t('bidding.bidding_cascading.bid_ladder.drop_here')}
      </Typography>
    </Box>
  )
}

export default BidLadderEmptyDropZone
